module.exports = __webpack_public_path__ + "img/746.13ea8af8.png";